import { AggregationSpecificationRequest } from "./types/request"

/**
 * Aggregate characteristic values.
 */
export class Aggregation {
    ids: string[]
    private viewIds: string[]
    private mergeValues: boolean[]

    constructor() {
        this.ids = []
        this.viewIds = []
        this.mergeValues = []
    }

    /**
     * IDs of characteristics. The response will contain the aggregated characteristic values according to the given list.
     * @param cid the id to be appended
     * @return this
     */
    id(cid: string): this {
        this.ids.push(cid)
        return this
    }

    /**
     * IDs of characteristic views. The response will contain the aggregated characteristic values from these views.
     * @param id the view id to be appended
     * @return this
     */
    viewId(cid: string): this {
        this.viewIds.push(cid)
        return this
    }

    mergeAggregatedValues(merge: boolean): this {
        this.mergeValues.splice(0)
        this.mergeValues.push(merge)
        return this
    }

    build(): AggregationSpecificationRequest {
        const _ids = this.ids.length === 0 ? null : this.ids
        const _viewIds = this.viewIds.length === 0 ? null : this.viewIds
        const _mergeValues =
            this.mergeValues.length === 0 ? null : this.mergeValues[0]
        return {
            characteristicIds: _ids,
            characteristicViewIds: _viewIds,
            mergeAggregatedValues: _mergeValues
        }
    }
}
